var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComingsoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 150,
    viewBox: "0 0 350 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 150,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.235 93.4313L179.644 68.8396C182.162 62.5021 180.862 55.0271 175.744 49.8813C169.515 43.6521 159.819 43.0833 152.912 48.1208L163.312 58.5479L159.467 62.3667L149.094 51.9938C144.056 58.8729 144.625 68.5958 150.854 74.7979C155.892 79.8354 163.231 81.1625 169.515 78.8063L194.187 103.479C195.244 104.535 196.95 104.535 198.006 103.479L204.235 97.25C205.319 96.2208 205.319 94.5146 204.235 93.4313ZM196.11 97.7646L170.49 72.1438C168.837 73.3625 166.996 74.0938 165.073 74.3646C161.39 74.9063 157.517 73.7958 154.7 70.9792C152.127 68.4333 150.935 65.0208 151.125 61.6625L159.494 70.0313L170.977 58.5479L162.608 50.1792C165.967 49.9896 169.352 51.1813 171.925 53.7271C174.85 56.6521 175.96 60.6875 175.283 64.4521C174.958 66.375 174.146 68.1625 172.9 69.7604L198.494 95.3542L196.11 97.7646Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoon);
export default __webpack_public_path__ + "static/media/comingsoon.788de2fa4554d74959148b64bd1a696d.svg";
export { ForwardRef as ReactComponent };